import { UrlPathname } from './UrlPathname';

export function addSearchQueryToUrl(url: string, searchQuery: string) {
  const pathname = UrlPathname.create(url).value;

  const search = new URLSearchParams(searchQuery);

  const result = `${pathname}?${search.toString()}`;
  return result;
}
